export default __webpack_public_path__ + "static/2p_2-59d4966146c2699f05de22750603ced6.jpg";